import React from 'react';
import { useTranslation } from 'react-i18next'; // useTranslation hook-ის იმპორტი
import TanksGhidi from "../../../assets/images/TanksGhidi.png";
import TanksRodina from "../../../assets/images/TanksRodina.png";
import Amphora from "../../../assets/images/Amphora.png";
import Barrels from "../../../assets/images/Barrels.png";

function TanksBarriquesAnfora() {
  const { t } = useTranslation(); // useTranslation hook-ის გამოყენება

  const products = [
    {
      name: t("Tanks Ghidi"),
      description: t(
        "Ghidi Metal is one of the biggest and famous stainless-steel tank producers not only in Italy, but in the whole world. You will be able to find their high-quality metal tanks at our service."
      ),
      image: TanksGhidi,
    },
    {
      name: t("Tanks Rodina"),
      description: t(
        "Rodina is a stainless steel tank producing powerhouse known among the whole world. Here you can choose between numerous options according to your liking, whether it is fermentation; Cold-maturation or other type of tank."
      ),
      image: TanksRodina,
    },
    {
      name: t("Amphora"),
      description: t(
        "Combination of traditions and culture which provides a storage and fermentation jar for any type of the wine of your liking."
      ),
      image: Amphora,
    },
    {
      name: t("Barrels"),
      description: t(
        "Barrels have been one of the leading fermentation and storage vessels for centuries now. They can be used not only in winemaking but also in high alcohol beverage production."
      ),
      image: Barrels,
    },
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.image} alt={product.name} />
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TanksBarriquesAnfora;
